<div [class]="containerClass()" class="fixed z-1000 p-4 flex flex-col gap-3 pointer-events-none">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      [@slideIn]
      [class]="
        'flex items-center w-full max-w-xs p-4 rounded-lg shadow-lg pointer-events-auto ' +
        toastClasses[toast.severity]
      "
      role="alert"
    >
      <div
        [class]="
          'inline-flex items-center justify-center shrink-0 w-8 h-8 rounded-lg ' +
          iconClasses[toast.severity]
        "
      >
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path [attr.d]="iconPaths[toast.severity]" />
        </svg>
      </div>

      <div class="flex flex-col justify-start px-2">
        <div class="text-sm font-normal">{{ toast.message }}</div>
        @if (toast.description && toast.description !== '') {
          <div class="text-xs font-normal">{{ toast.description }}</div>
        }
      </div>

      <button
        type="button"
        (click)="toastService.remove(toast.id)"
        class="ms-auto -mx-1.5 -my-1.5 rounded-lg p-1.5 inline-flex items-center justify-center h-8 w-8 hover:bg-black/10 transition-colors"
        aria-label="Cerrar"
      >
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 14 14" stroke-width="2">
          <path
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  }
</div>
